import type { Action, Computed } from 'easy-peasy';
import { action, computed } from 'easy-peasy';

export interface BarcodeScanEvent {
  timestamp: number;
  barcode: string;
  pathname: string;
}

export interface BarcodeScanModel {
  scanBuffer: string[];
  clearScanBuffer: Action<BarcodeScanModel, void>;
  receiveKey: Action<BarcodeScanModel, string>;
  scannedBarcodes: BarcodeScanEvent[];
  lastScan: Computed<BarcodeScanModel, BarcodeScanEvent | undefined>;
}

export const barcodeScanModel: BarcodeScanModel = {
  scanBuffer: [],
  scannedBarcodes: [],
  receiveKey: action((state, payload) => {
    if (payload === 'Enter') {
      const timestamp = new Date().valueOf();
      state.scannedBarcodes.push({
        barcode: state.scanBuffer.join(''),
        timestamp,
        pathname: window.location.pathname,
      });
      state.scanBuffer = [];
    } else {
      state.scanBuffer = [...state.scanBuffer, payload];
    }
  }),
  clearScanBuffer: action((state, payload) => {
    state.scanBuffer = [];
  }),
  lastScan: computed((state) => {
    if (state.scannedBarcodes.length > 0) {
      return state.scannedBarcodes.sort((a, b) => a.timestamp - b.timestamp).reverse()[0];
    }
  }),
};
